<template lang="pug">
.d-file-item.d-flex.pa-3.gc-2.gap-8.ui-neutral--text.text--lighten-1(
  v-bind="extendAttrs"
  v-on="extendListeners"
)
  v-icon(
    v-if="!hidePrependIcon"
    :size="20"
  ) $ui-document-arrow-up
  slot(name="prepend")
  .d-flex.flex-column.gr-1.gap-4
    h3.ui-h3.ui-neutral--text
      slot(name="name") {{ name }}
    p.ui-body-2
      slot(name="description") {{ description }}
  slot(name="append")
  dv-btn.align-self-center.ml-auto(
    v-if="close"
    color="ui-neutral lighten-1"
    icon
    x-small
    @click.stop.prevent="$emit('click:close', file)"
  ): v-icon(:size="20") $ui-close
</template>

<script>
import { getExtensionFromName, getFileSize } from './helpers';
import DvBtn from '../buttons/DvBtn.vue';

export default {
  components: {
    DvBtn,
  },
  props: {
    file: { type: Object, default: () => ({}) },
    close: { type: Boolean, default: false },
    hidePrependIcon: { type: Boolean, default: false },
  },
  data() {
    return {};
  },
  computed: {
    name() {
      const { name, file } = this.file;
      return name || file?.name || 'Документ';
    },
    description() {
      const extension = getExtensionFromName(this.name);
      const { file } = this.file;
      const size = file?.size ? getFileSize(file?.size || 0) : null;
      return [
        ...extension ? [extension] : [],
        ...size ? [size] : [],
      ].join(' • ');
    },
    url() {
      const { url } = this.file;
      return url || null;
    },
    extendAttrs() {
      const { url } = this;
      return {
        ...url ? { class: 'clickable' } : {},
        ...this.$attrs,
      };
    },
    extendListeners() {
      const { url } = this;
      return {
        ...url ? {
          click: () => {
            window.open(url, '_blank');
          },
        } : {},
        ...this.$listeners,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.d-file-item {
  border-radius: 12px;
  background-color: #{$ui-background};
  & h3 {
    word-break: break-word;
  }
  &.clickable {
    cursor: pointer;
  }
}
</style>
